(function () {
  'use strict';
  /* =========================================================
     BAESOLE ANALYTICS EVENT LAYER — additive only.
     No third-party SDK. Publishes interactions as dataLayer
     pushes (GA4-ready) and mirrors them as document
     CustomEvents with the same name, so any consumer can
     subscribe later. Never interferes with existing handlers:
     everything below is passive listening / event delegation.
     ========================================================= */
  window.dataLayer = window.dataLayer || [];

  function track(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    try { window.dataLayer.push(payload); } catch (err) {}
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (err) {}
  }

  /* Find My Size / Size Guide — dispatched by baesole-size.js */
  document.addEventListener('bae:size:open', function (e) {
    var d = (e && e.detail) || {};
    track(d.tab === 'table' ? 'bae_sizeguide_open' : 'bae_findmysize_open', { fit: d.fit });
  });
  document.addEventListener('bae:size:result', function (e) {
    track('bae_findmysize_result', (e && e.detail) || {});
  });

  /* Colour swatches — PDP colour tiles + card swatches (delegated). */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var tile = e.target.closest('a.bae-pdp__colourtile');
    if (tile) {
      track('bae_swatch_click', { surface: 'pdp', label: tile.getAttribute('title') || '', href: tile.getAttribute('href') || '' });
      return;
    }
    var sw = e.target.closest('[data-bae-swatch]');
    if (sw) {
      track('bae_swatch_click', { surface: 'card', label: sw.dataset.colour || '', href: sw.dataset.variantUrl || '' });
      return;
    }

    /* Product / On model toggle */
    var view = e.target.closest('[data-bae-view]');
    if (view) {
      track('bae_view_toggle', { view: view.dataset.baeView || '' });
      return;
    }

    /* Shop the Look product clicks */
    var stl = e.target.closest('.bae-stl [data-bae-card] a.bae-card__link, .bae-stl [data-bae-card] a.bae-card__name');
    if (stl) {
      var card = stl.closest('[data-bae-card]');
      track('bae_stl_click', { handle: (card && card.dataset.productHandle) || '', href: stl.getAttribute('href') || '' });
    }
  }, true);

  /* Add to cart — existing event dispatched by PDP, quick add and sticky ATC. */
  document.addEventListener('bae:cart:updated', function (e) {
    var cart = (e && e.detail) || {};
    track('bae_atc', { item_count: cart.item_count, total_price: cart.total_price });
  });

  /* Free-shipping threshold reached — dispatched by the cart drawer. */
  document.addEventListener('bae:ship:unlocked', function (e) {
    track('bae_shipping_unlocked', (e && e.detail) || {});
  });
})();
